var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = {
    "dismiss": `Ignora`
};


export {$e933f298574dc435$exports as default};
//# sourceMappingURL=it-IT.mjs.map
